import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CIPXCancelButtonComponent } from '@sbd-doug-frontend/shared/lib/ui';

@Component({
  selector: 'sbd-send-reminder-dialog',
  standalone: true,
  imports: [NgIf, MatDialogModule, MatIconModule, MatButtonModule, MatTooltipModule, CIPXCancelButtonComponent],
  template: `
    <h2 mat-dialog-title class="text-lg font-semibold">Send Reminder</h2>

    <div mat-dialog-content class="flex flex-col gap-3">
      <p class="text-sm text-gray-600">
        {{
          data.mailto
            ? 'Choose an action for this reminder.'
            : (data.contactName || 'This contact') +
              ' does not have an email address on file. You can copy the purchase link and send it to them yourself,' +
              ' or reach out to your surety team to make updates.'
        }}
      </p>

      <div class="flex flex-col gap-2 md:flex-row md:gap-3">
        <button
          mat-stroked-button
          color="primary"
          class="w-full md:w-1/2 text-sm flex items-center gap-2"
          [disabled]="!data.jumpUrl"
          (click)="copyJumpUrl()">
          <mat-icon class="icon-size-4">content_copy</mat-icon>
          <span>Copy URL</span>
        </button>

        <a
          mat-stroked-button
          color="primary"
          class="w-full md:w-1/2 text-sm flex items-center gap-2"
          [disabled]="!data.mailto"
          [attr.href]="data.mailto || null"
          (click)="dialogRef.close()">
          <mat-icon class="icon-size-4">email</mat-icon>
          <span>Send Email</span>
        </a>
      </div>

      <div class="text-xs text-primary h-4" *ngIf="statusMessage">{{ statusMessage }}</div>
    </div>

    <div mat-dialog-actions class="flex justify-end">
      <cipx-cancel-button (buttonClick)="dialogRef.close()">Close</cipx-cancel-button>
    </div>
  `,
})
export class SendReminderDialogComponent {
  statusMessage = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { mailto: string; jumpUrl: string; contactName?: string },
    public dialogRef: MatDialogRef<SendReminderDialogComponent>,
  ) {
  }

  copyJumpUrl() {
    if (!this.data?.jumpUrl) return;

    navigator.clipboard.writeText(this.data.jumpUrl)
      .then(() => {
        this.statusMessage = 'URL copied to clipboard';
      })
      .catch(() => {
        this.statusMessage = 'Unable to copy URL';
      });
  }

}
